// A session recording stores the page address by a route the Sentry beforeSend hooks cannot reach, so a route that
// carries a secret in its path must never be recorded at all. Kept literal on purpose: this module sits in the import
// graph of most of the app, and reading a route constant at load time breaks under a partial mock of constants/env.
const DENIED_PATH_PREFIXES = ["/choose-password"];

export function isRecordingDeniedPath(pathname: string): boolean {
  return DENIED_PATH_PREFIXES.some(function matchesPrefix(prefix) {
    return pathname === prefix || pathname.startsWith(`${prefix}/`);
  });
}
